import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { MessageService } from 'primeng/api';
import { EMPTY, Observable, concatAll, expand, finalize, map, tap, toArray } from 'rxjs';
import * as XLSX from 'xlsx';
import { IPaginateRequest } from '../interfaces/paginate-request.interface';
import { IPaginateResponse } from '../interfaces/paginate-response.interface';

const jsonToXlsx = (jsonData: any) => {
  const wb = XLSX.utils.book_new();
  const newWs = XLSX.utils.json_to_sheet(jsonData);
  XLSX.utils.book_append_sheet(wb, newWs);
  const rawExcel = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
  return rawExcel;
};
interface ListProvider {
  list: (payload: IPaginateRequest<unknown>) => Observable<IPaginateResponse<unknown>>;
}

@Injectable()
export class ChunkDownloadService {
  constructor(private msgService: MessageService) {}

  downloadCSV(service: ListProvider, payload: IPaginateRequest<any>, mapping: (value: any) => any, fileName?: string) {
    return this.getChunks(service, payload).pipe(
      concatAll(),
      map(mapping),
      toArray(),
      map((mapped) => this.downloadFile(mapped, fileName)),
    );
  }
  private getChunks(service: ListProvider, payload: IPaginateRequest<unknown>) {
    const STEP = 500;
    let count = 0;
    payload.limit = STEP;
    return service.list(payload).pipe(
      tap((firstResponse) => {
        this.msgService.add({
          severity: 'success',
          summary: 'Download',
          detail: `Download avviato correttamente - ${firstResponse.total} elementi da elaborare`,
          life: 2000,
        });
      }),
      expand((value) => {
        if (count <= value.total) {
          if (count >= 20_000) {
            this.msgService.add({
              severity: 'warn',
              summary: 'Download',
              detail: 'Hai raggiunto il limite di 20000 elementi',
              life: 1000,
            });
            return EMPTY;
          }
          payload.skip += STEP;
          count += STEP;
          return service.list(payload);
        } else {
          return EMPTY;
        }
      }),
      toArray(),
      map((values) => values.reduce((a, b) => a.concat(b.data), [] as unknown[])),
    );
  }

  private downloadFile(data: any, fileName?: string) {
    const replacer = (value: any) => (value === null || value === undefined ? '' : value);
    const header = Object.keys(data[0]);
    const csv = data.map((row: any) =>
      header.map((fieldName: any) => JSON.stringify(row[fieldName], replacer)).join(','),
    );
    csv.unshift(header.join(','));
    const a = document.createElement('a');
    const blob = new Blob([jsonToXlsx(data)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
    });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName || dayjs().format('DD-MM-YYYY HH:ss') + '.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
